/* tslint:disable */
/* eslint-disable */
/**
 * AS3.Portals
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HelpLink } from './HelpLink';
import {
    HelpLinkFromJSON,
    HelpLinkFromJSONTyped,
    HelpLinkToJSON,
} from './HelpLink';
import type { Parent } from './Parent';
import {
    ParentFromJSON,
    ParentFromJSONTyped,
    ParentToJSON,
} from './Parent';

/**
 * 
 * @export
 * @interface DocumentSection
 */
export interface DocumentSection {
    /**
     * 
     * @type {number}
     * @memberof DocumentSection
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof DocumentSection
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentSection
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentSection
     */
    type?: string;
    /**
     * 
     * @type {Parent}
     * @memberof DocumentSection
     */
    parent?: Parent;
    /**
     * 
     * @type {string}
     * @memberof DocumentSection
     */
    urlName?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentSection
     */
    readonly updateDate?: string;
    /**
     * 
     * @type {Date}
     * @memberof DocumentSection
     */
    publishedDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof DocumentSection
     */
    helpText?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentSection
     */
    helpVideo?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentSection
     */
    showHelp?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentSection
     */
    showExtendedHelp?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentSection
     */
    pushContent?: boolean;
    /**
     * 
     * @type {Array<HelpLink>}
     * @memberof DocumentSection
     */
    helpLinks?: Array<HelpLink>;
    /**
     * 
     * @type {string}
     * @memberof DocumentSection
     */
    status?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentSection
     */
    disallowDeletion?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DocumentSection
     */
    otherProgramsTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentSection
     */
    otherProgramsDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentSection
     */
    subTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentSection
     */
    deleteDocumentConfirmationHeader?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentSection
     */
    deleteDocumentConfirmationDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentSection
     */
    dragAndDropDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentSection
     */
    dragAndDropSubmitDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentSection
     */
    yourDocuments?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentSection
     */
    addCV?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentSection
     */
    addedCVToProfile?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentSection
     */
    newDocuments?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentSection
     */
    seeImagePreview?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentSection
     */
    uploadButtonText?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentSection
     */
    selectDocumentType?: string;
}

/**
 * Check if a given object implements the DocumentSection interface.
 */
export function instanceOfDocumentSection(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DocumentSectionFromJSON(json: any): DocumentSection {
    return DocumentSectionFromJSONTyped(json, false);
}

export function DocumentSectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentSection {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'Id') ? undefined : json['Id'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'url': !exists(json, 'Url') ? undefined : json['Url'],
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'parent': !exists(json, 'Parent') ? undefined : ParentFromJSON(json['Parent']),
        'urlName': !exists(json, 'UrlName') ? undefined : json['UrlName'],
        'updateDate': !exists(json, 'UpdateDate') ? undefined : json['UpdateDate'],
        'publishedDate': !exists(json, 'PublishedDate') ? undefined : (new Date(json['PublishedDate'])),
        'helpText': !exists(json, 'HelpText') ? undefined : json['HelpText'],
        'helpVideo': !exists(json, 'HelpVideo') ? undefined : json['HelpVideo'],
        'showHelp': !exists(json, 'ShowHelp') ? undefined : json['ShowHelp'],
        'showExtendedHelp': !exists(json, 'ShowExtendedHelp') ? undefined : json['ShowExtendedHelp'],
        'pushContent': !exists(json, 'PushContent') ? undefined : json['PushContent'],
        'helpLinks': !exists(json, 'HelpLinks') ? undefined : ((json['HelpLinks'] as Array<any>).map(HelpLinkFromJSON)),
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'disallowDeletion': !exists(json, 'DisallowDeletion') ? undefined : json['DisallowDeletion'],
        'otherProgramsTitle': !exists(json, 'OtherProgramsTitle') ? undefined : json['OtherProgramsTitle'],
        'otherProgramsDescription': !exists(json, 'OtherProgramsDescription') ? undefined : json['OtherProgramsDescription'],
        'subTitle': !exists(json, 'SubTitle') ? undefined : json['SubTitle'],
        'deleteDocumentConfirmationHeader': !exists(json, 'DeleteDocumentConfirmationHeader') ? undefined : json['DeleteDocumentConfirmationHeader'],
        'deleteDocumentConfirmationDescription': !exists(json, 'DeleteDocumentConfirmationDescription') ? undefined : json['DeleteDocumentConfirmationDescription'],
        'dragAndDropDescription': !exists(json, 'DragAndDropDescription') ? undefined : json['DragAndDropDescription'],
        'dragAndDropSubmitDescription': !exists(json, 'DragAndDropSubmitDescription') ? undefined : json['DragAndDropSubmitDescription'],
        'yourDocuments': !exists(json, 'YourDocuments') ? undefined : json['YourDocuments'],
        'addCV': !exists(json, 'AddCV') ? undefined : json['AddCV'],
        'addedCVToProfile': !exists(json, 'AddedCVToProfile') ? undefined : json['AddedCVToProfile'],
        'newDocuments': !exists(json, 'NewDocuments') ? undefined : json['NewDocuments'],
        'seeImagePreview': !exists(json, 'SeeImagePreview') ? undefined : json['SeeImagePreview'],
        'uploadButtonText': !exists(json, 'UploadButtonText') ? undefined : json['UploadButtonText'],
        'selectDocumentType': !exists(json, 'SelectDocumentType') ? undefined : json['SelectDocumentType'],
    };
}

export function DocumentSectionToJSON(value?: DocumentSection | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'Title': value.title,
        'Url': value.url,
        'Type': value.type,
        'Parent': ParentToJSON(value.parent),
        'UrlName': value.urlName,
        'PublishedDate': value.publishedDate === undefined ? undefined : (value.publishedDate.toISOString()),
        'HelpText': value.helpText,
        'HelpVideo': value.helpVideo,
        'ShowHelp': value.showHelp,
        'ShowExtendedHelp': value.showExtendedHelp,
        'PushContent': value.pushContent,
        'HelpLinks': value.helpLinks === undefined ? undefined : ((value.helpLinks as Array<any>).map(HelpLinkToJSON)),
        'Status': value.status,
        'DisallowDeletion': value.disallowDeletion,
        'OtherProgramsTitle': value.otherProgramsTitle,
        'OtherProgramsDescription': value.otherProgramsDescription,
        'SubTitle': value.subTitle,
        'DeleteDocumentConfirmationHeader': value.deleteDocumentConfirmationHeader,
        'DeleteDocumentConfirmationDescription': value.deleteDocumentConfirmationDescription,
        'DragAndDropDescription': value.dragAndDropDescription,
        'DragAndDropSubmitDescription': value.dragAndDropSubmitDescription,
        'YourDocuments': value.yourDocuments,
        'AddCV': value.addCV,
        'AddedCVToProfile': value.addedCVToProfile,
        'NewDocuments': value.newDocuments,
        'SeeImagePreview': value.seeImagePreview,
        'UploadButtonText': value.uploadButtonText,
        'SelectDocumentType': value.selectDocumentType,
    };
}

